<template>
    <!-- <section id="cadastro" :style="{ 'background-image': 'url(' + background + ')' }"> -->
    <section id="cadastro">
        <div class="container">
            <h1>{{ $t('cadastro.titulo') }}</h1>

            <b-form @submit.prevent="preparaCadastro">

                <p class="alert alert-secondary small text-center text-secondary">Os campos marcados com <strong>*</strong> são obrigatórios!</p>

                <!-- Nome completo -->
                <div class="row">
                    <!-- País -->
                    <div v-bind:class="[fastCheckout ? 'col-md-6' : 'col-md-12']" class="col-sm-12">
                        <b-form-group :label="$t('cadastro.pais.label')" label-for="pais">
                            <b-form-select
                                id="pais"
                                :value="null"
                                :options="listaPais"
                                :state="hasError.country"
                                v-model="form.address.country"
                                @change="limpaCidade"
                            >
                                <template v-slot:first>
                                    <option value="BR">Brasil</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <!-- Cidade - Fast Checkout -->
                    <div class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.cidade.label')" label-for="cidade">
                            <autocomplete
                                v-if="form.address.country === 'BR'"
                                :search="search"
                                placeholder="Cidade de origem"
                                aria-label="Cidade de origem"
                                autoSelect
                            ></autocomplete>
                            <b-form-input
                                v-if="form.address.country !== 'BR'"
                                id="cidade"
                                class="cidade-autocomplete"
                                v-model="form.address.city"
                                type=text
                                required
                                :state="hasError.city"
                                :placeholder="$t('cadastro.cidade.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <hr class="col-md-12" style="max-width: calc(100% - 30px)!importantpadding: 0"/>

                    <!-- Nome -->
                    <div class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.nome.label')" label-for="nome">
                            <b-form-input
                                id="nome"
                                v-model="form.user.first_name"
                                type=text
                                required
                                :state="hasError.first_name"
                                :placeholder="$t('cadastro.nome.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- Sobrenome -->
                    <div class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.sobrenome.label')" label-for="sobrenome">
                            <b-form-input
                                id="sobrenome"
                                v-model="form.user.last_name"
                                type=text
                                required
                                :state="hasError.last_name"
                                :placeholder="$t('cadastro.sobrenome.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Telefone -->
                    <div v-bind:class="[form.address.country === 'BR' ? 'col-md-4' : 'col-md-6']" class="col-sm-12">
                        <b-form-group :label="$t('cadastro.telefone.label')" label-for="telefone">
                            <b-form-input
                                id="telefone"
                                v-model="form.user.phone"
                                type=text
                                required
                                v-mask="form.address.country === 'BR' ? ['(##) # ####-####'] : ['## ##############']"
                                :state="hasError.phone"
                                :placeholder="$t('cadastro.telefone.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- CPF -->
                    <div v-if="form.address.country === 'BR'" class="col-md-4 col-sm-12">
                        <b-form-group :label="$t('cadastro.cpf.label')" label-for="cpf">
                            <b-form-input
                                id="cpf"
                                v-model="form.user.cpf"
                                type=text
                                required
                                v-mask="['###.###.###-##']"
                                :state="hasError.cpf"
                                :placeholder="$t('cadastro.cpf.placeholder')"
                                :disabled="form.address.country !== 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- Aniversário -->
                    <div v-bind:class="[form.address.country === 'BR' ? 'col-md-4' : 'col-md-6']" class="col-sm-12">
                        <b-form-group :label="$t('cadastro.aniversario.label')" label-for="aniversario">
                            <b-form-input
                                id="aniversario"
                                v-model="birthdayTemp"
                                type=text
                                required
                                v-mask="['##/##/####']"
                                :state="hasError.birthday"
                                :placeholder="$t('cadastro.aniversario.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <hr class="col-md-12" v-if="!fastCheckout" style="max-width: calc(100% - 30px)!importantpadding: 0"/>

                    <!-- CEP -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.cep.label')" label-for="cep">
                            <b-form-input
                                id="cep"
                                v-model="form.address.post_code"
                                type=text
                                required
                                v-mask="['#####-###']"
                                :state="hasError.post_code"
                                :placeholder="$t('cadastro.cep.placeholder')"
                                :disabled="form.address.country != 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Estado -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.estado.label')" label-for="estado">
                            <b-form-input
                                v-if="form.address.country !== 'BR'"
                                id="estado"
                                v-model="form.address.state"
                                type=text
                                :state="hasError.state"
                                :placeholder="$t('cadastro.estado.placeholder')"
                            ></b-form-input>
                            <b-form-select
                                v-if="form.address.country === 'BR'"
                                :value="null"
                                :options="listaEstados"
                                :state="hasError.state"
                                v-model="form.address.state"
                                required
                                id="estado"
                                @change="consultaMunicipios($event.code)"
                                >
                                <template v-slot:first>
                                    <option :value="null">Escolha...</option>
                                </template>
                            </b-form-select>
                        </b-form-group>

                    </div>
                    <!-- Cidade -->
                    <div class="col-md-6 col-sm-12" v-if="!fastCheckout">
                        <b-form-group :label="$t('cadastro.cidade.label')" label-for="cidade">
                            <b-form-input
                                v-if="form.address.country !== 'BR'"
                                id="cidade"
                                v-model="form.address.city"
                                type=text
                                required
                                :state="hasError.city"
                                :placeholder="$t('cadastro.cidade.placeholder')"
                            ></b-form-input>
                            <b-form-select
                                v-if="form.address.country === 'BR'"
                                :value="null"
                                :options="listaCidades"
                                :state="hasError.city"
                                v-model="form.address.city"
                                required
                                id="cidade"
                                >
                                <template v-slot:first>
                                    <option :value="null">Escolha...</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <!-- Bairro -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-md-6 col-sm-12">
                        <b-form-group :label="$t('cadastro.bairro.label')" label-for="bairro">
                            <b-form-input
                                id="bairro"
                                v-model="form.address.district"
                                type=text
                                :required="form.address.country === 'BR'"
                                :state="hasError.district"
                                :placeholder="$t('cadastro.bairro.placeholder')"
                                :disabled="form.address.country !== 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Rua -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-md-8 col-sm-12">
                        <b-form-group :label="$t('cadastro.rua.label')" label-for="rua">
                            <b-form-input
                                id="rua"
                                v-model="form.address.street"
                                type=text
                                :required="form.address.country === 'BR'"
                                :state="hasError.street"
                                :placeholder="$t('cadastro.rua.placeholder')"
                                :disabled="form.address.country !== 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Número -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-4">
                        <b-form-group :label="$t('cadastro.numero.label')" label-for="numero">
                            <b-form-input
                                id="numero"
                                v-model="form.address.number"
                                type=text
                                :required="form.address.country === 'BR'"
                                :state="hasError.number"
                                :placeholder="$t('cadastro.numero.placeholder')"
                                :disabled="form.address.country !== 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Complemento -->
                    <div v-if="form.address.country === 'BR' && !fastCheckout" class="col-12">
                        <b-form-group :label="$t('cadastro.complemento.label')" label-for="complemento">
                            <b-form-input
                                id="complemento"
                                v-model="form.address.complement"
                                type=text
                                :placeholder="$t('cadastro.complemento.placeholder')"
                                :disabled="form.address.country !== 'BR'"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <hr/>

                <!-- E-mail e Senha -->
                <div class="row">
                    <div class="col-md-12">
                        <!-- E-mail -->
                        <b-form-group :label="$t('cadastro.email.label')" label-for="email">
                            <b-form-input
                                id="email"
                                v-model="form.user.email"
                                type="email"
                                required
                                :state="hasError.email"
                                :placeholder="$t('cadastro.email.placeholder')"
                            ></b-form-input>
                        </b-form-group>

                        <!-- Senha -->
                        <b-form-group :label="$t('cadastro.senha.label')" :description="$t('cadastro.senha.descricao')" label-for="password">
                            <b-form-input
                                id="password"
                                v-model="form.user.password"
                                type="password"
                                required
                                :state="hasError.password"
                                :placeholder="$t('cadastro.senha.placeholder')"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <hr/>

                <!-- Botões -->
                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-success">{{ $t('cadastro.botao.finalizar') }}</button>
                    </div>
                </div>
            </b-form>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import Autocomplete from '@trevoreyre/autocomplete-vue'

import JsonListaPaises from '@/assets/json/listaPaises.json'
import JsonListaEstados from '@/assets/json/listaEstados.json'
import JsonListaMunicipios from '@/assets/json/listaMunicipios.json'

export default {
    components: {
        Autocomplete
    },
    data () {
        return {
            fastCheckout: true,
            listaPais: JsonListaPaises,
            listaEstados: JsonListaEstados,
            listaMunicipios: JsonListaMunicipios,
            listaCidades: [],
            birthdayTemp: '',
            form: {
                // Dados do usuário
                user: {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    cpf: '',
                    email: '',
                    password: '',
                    birthday: ''
                },

                // Dados de enderço
                address: {
                    post_code: '',
                    city: '',
                    state: '',
                    country: 'BR',
                    street: '',
                    district: '',
                    complement: '',
                    number: ''
                }
            },

            // Mostra o erro no front-end
            hasError: {
                first_name: null,
                last_name: null,
                phone: null,
                cpf: null,
                email: null,
                password: null,
                birthday: null,
                post_code: null,
                city: null,
                state: null,
                country: null,
                street: null,
                district: null,
                complement: null,
                number: null
            }
        }
    },
    methods: {
        ...mapActions('auth', ['ActionDoCreate']),

        /**
         * Limpa o campo de cidade quando o muda o país
         */
        limpaCidade () {
            this.form.address.city = ''
        },

        /**
         * Prepara os dados para validação e cadastro
         */
        preparaCadastro () {
            const { birthdayTemp, form: { user, address } } = this

            // Prepara o Aniversário
            user.birthday = this.stringToDate(birthdayTemp)

            // Valida os campos obrigatórios
            if (this.validaFormulario(user, address)) {
                this.submit(user, address)
            };
        },

        /**
         * COnverte string 00/00/0000 para new Date()
         */
        stringToDate (data) {
            if (typeof data === 'string') {
                var d = data.split('/')
                return new Date(d[1] + '/' + d[0] + '/' + d[2])
            }

            return null
        },

        /**
         * Converte data para string 0000/00/00
         */
        dateToString (date) {
            return date.toISOString().split('T')[0]
        },

        /**
         * Valida os campos obrigatórios do from
         */
        validaFormulario (user, address) {
            // Remove todas as validações!
            this.resetHasError()

            // Valida Nome
            if (user.first_name.length <= 2) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.nome.erro')
                })
                this.hasError.first_name = false
                return false
            }

            // Valida Sobrenome
            if (user.last_name.length <= 0) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.sobrenome.erro')
                })
                this.hasError.last_name = false
                return false
            }

            // Valida Telefone
            if (user.phone.length <= 0) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.telefone.erro')
                })
                this.hasError.phone = false
                return false
            }

            // Valida CPF
            if (user.cpf.length !== 14 && address.country === 'BR') {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.cpf.erro')
                })
                this.hasError.cpf = false
                return false
            }

            // Data de Aniversário
            if (isNaN(this.stringToDate(this.birthdayTemp))) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.aniversario.erro')
                })
                this.hasError.birthday = false
                return false
            }

            // Valida País
            if (address.country.length <= 0) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.pais.erro')
                })
                this.hasError.country = false
                return false
            }

            // Valida se o país for Brasil
            if (address.country === 'BR') {
                // Valida CEP
                if (address.post_code.length !== 9 && !this.fastCheckout) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.cep.erro')
                    })
                    this.hasError.post_code = false
                    return false
                }

                // Valida Rua
                if (address.street.length <= 0 && !this.fastCheckout) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.rua.erro')
                    })
                    this.hasError.street = false
                    return false
                }

                // Valida Estado
                if (address.state.length <= 0) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.estado.erro')
                    })
                    this.hasError.state = false
                    return false
                }

                // Valida Cidade
                if (address.city.length <= 0) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.cidade.erro')
                    })
                    this.hasError.city = false
                    return false
                }

                // Valida bairro
                if (address.district.length <= 0 && !this.fastCheckout) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.bairro.erro')
                    })
                    this.hasError.district = false
                    return false
                }

                // Valida Numero
                if (address.number.length <= 0 && !this.fastCheckout) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.numero.erro')
                    })
                    this.hasError.number = false
                    return false
                }
            } else {
                // Valida Cidade
                if (address.city.length <= 0) {
                    this.$notify({
                        duration: 10000,
                        group: 'foo',
                        type: 'warn',
                        title: 'Ops!',
                        text: this.$t('cadastro.cidade.erro')
                    })
                    this.hasError.city = false
                    return false
                }
            }

            // Valida E-mail
            const mailReg = new RegExp('^($|[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+)$')
            if (!mailReg.test(user.email)) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.email.erro')
                })
                this.hasError.email = false
                return false
            }

            // Valida senha
            if (user.password.length < 6) {
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'warn',
                    title: 'Ops!',
                    text: this.$t('cadastro.senha.erro')
                })
                this.hasError.password = false
                return false
            }

            // Tudo OK
            return true
        },

        /**
         * Retira todas as notificações de erro do Front-end
         */
        resetHasError () {
            for (var key in this.hasError) {
                this.hasError[key] = null
            }
        },

        /**
         * Retorna os dados completos do estado informado
         */
        procuraUFNaLista (uf) {
            if (uf) {
                for (var index = 0; index < this.listaEstados.length; index++) {
                    if (this.listaEstados[index].value.uf === uf.toLowerCase()) {
                        return this.listaEstados[index].value
                    }
                }
            }
            return {}
        },

        /**
         * Retorana os dados completos do município informado
         */
        consultaMunicipios (codigoEstado) {
            if (this.form.address.country === 'BR') {
                const _this = this
                axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + codigoEstado + '/municipios')
                    .then(response => {
                        if (response.status === 200) {
                            console.log('Estados response', response)
                            _this.listaCidades = response.data.map(data => {
                                return { value: data.nome, text: data.nome }
                            })
                        }
                    })
            }
        },

        /**
         * Consulta o CEP na base dos correios
         */
        consultaCEP (event) {
            // Preserva o contexto;
            // var _this = this

            // Captura o CEP digitado
            var cep = event.target.value

            // Se CEP for válido
            if (cep.length === 9) {
                const _this = this

                axios.get('https://viacep.com.br/ws/' + cep + '/json/')
                    .then(response => {
                        if (response.status === 200 && !response.data.erro) {
                            console.log(response.data)
                            const { uf, localidade, logradouro, bairro } = response.data
                            _this.form.address.state = _this.procuraUFNaLista(uf)

                            _this.consultaMunicipios(_this.form.address.state.code)

                            _this.form.address.district = bairro
                            _this.form.address.city = localidade
                            _this.form.address.street = logradouro
                        } else {
                            this.$notify({
                                duration: 10000,
                                group: 'foo',
                                type: 'error',
                                title: 'Ops!',
                                text: 'CEP Não encontrado!'
                            })
                        }
                    })
            }
        },

        /**
         * Envia o formulário para a API de cadastro
         */
        async submit (user, address) {
            const data = {
                first_name: user.first_name,
                last_name: user.last_name,
                phone: user.phone,
                cpf: user.cpf,
                email: user.email,
                password: user.password,
                birthday: this.dateToString(user.birthday),
                address: {
                    post_code: address.post_code,
                    city: address.city.value || address.city,
                    state: address.state.uf || address.state,
                    country: address.country,
                    street: address.street,
                    district: address.district,
                    complement: address.complement,
                    number: address.number
                }
            }

            try {
                await this.ActionDoCreate(data)
                // this.$router.go({ name: 'home' })
                this.$router.push(this.$route.query.from || '/')
            } catch (err) {
                console.error(err)
                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'error',
                    title: 'Ops!',
                    text: err.data.message || 'Ocorreu um erro inesperado! Por favor tente novamente mais tarde ou entre em contato conosco.'
                })
            }
        },

        /**
         * Procura o município na lista de Municípios
         */
        search (input) {
            if (input.length < 1) { return [] }
            return this.listaMunicipios.filter(country => {
                return country.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').startsWith(input.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
            })
        },

        /**
         * Atribui a cidade selecionada na lista de Municípios
         */
        setCityName (element) {
            var cidade = this.listaMunicipios.find(function (item) {
                return item === element.value
            })

            if (cidade) {
                try {
                    this.form.address.city = element.value.split('(')[0]
                    this.form.address.state = element.value.split('(')[1].replace(')', '')
                    return
                } catch (err) {
                    console.error(err)
                }
            }

            this.form.address.city = ''
            this.form.address.state = ''
            element.value = ''
        }
    },
    mounted () {
        const _this = this
        const cepEl = document.getElementById('cep')
        const autocompleteEl = document.querySelector('.autocomplete input')

        if (cepEl) cepEl.addEventListener('keyup', this.consultaCEP)
        if (autocompleteEl) {
            autocompleteEl.addEventListener('focusout', function (el) {
                _this.setCityName(el.target)
            })
        }

        // this.birthdayTemp = '01/11/1990'
        // this.form.user.first_name = 'Felipe Augusto'
        // this.form.user.last_name = 'Feitosa'
        // this.form.user.phone = '(47) 9 9616-8262'
        // this.form.user.cpf = '029.441.631-59'
        // this.form.user.email = 'felipe.aufe@gmail.com'
        // this.form.user.password = '123456'
        // this.form.user.birthday = new Date('11/01/1990')

        // this.form.address.post_code = '88337-500'
        // this.form.address.city = 'Balneário Camboriú'
        // this.form.address.state = { 'uf': 'sc', 'code': '42' }
        // this.form.address.country = 'BR'
        // this.form.address.street = 'Massaranduba'
        // this.form.address.district = 'Tabuleiro'
        // this.form.address.complement = 'Teste'
        // this.form.address.number = '142'
    }
}
</script>

<style lang="sass">
    #cadastro
        padding-top: 120px
        padding-bottom: 50px
        #pais
            pointer-events: none
        > div
            display: flex
            flex-direction: column
            padding: 10px
            max-width: 600px
            h1
                margin: 0 auto 50px
            .btn
                min-width: 250px
                margin: 0 auto 5px
            .vdp-datepicker
                input
                    margin-top: 0!important
                    margin-bottom: 10px
                    width: 100%
                    height: 38px
                    border-radius: 5px
                    padding: .375rem .75rem
                    border: 1px solid #ced4da
        .autocomplete
            input
                margin-top: 0!important
                margin-bottom: 10px
                width: 100%
                height: 38px
                border-radius: 5px
                padding: .375rem .75rem
                border: 1px solid #ced4da
            .autocomplete-result-list
                background-color: white
                border-radius: 5px
                top: 48px!important
                padding: 0
                box-shadow: 0px 2px 7px -5px black
                max-height: 160px
                overflow-y: scroll
                li
                    list-style: none
                    padding: 10px
                    &:hover
                        background-color: #eaeaea
                        cursor: pointer
</style>
